import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { Breadcrumbs } from '../../components/Breadcrumbs';
import { PATH_DATA } from '../../app/constants/paths.constant';
import { Page } from '../../contexts/NavigationContext/enums/page.enum';
import { useNavigationContext } from '../../contexts/NavigationContext/hooks/useNavigationContext.hook';
import { buildDocumentTitle } from '../../utils/document-title.util';
import { PageTitle } from '../../components/PageTitle';

import { DataSetLoadingForm } from './DataSetLoadingForm';
import { useAppSettingsQuery } from './hooks/useAppSettingsQuery.hook';
import { InfoAlert } from '../../components/InfoAlert';

export const DataPage = () => {
  const { setPage } = useNavigationContext();

  useEffect(() => {
    setPage(Page.Data);
  }, [setPage]);

  const { data, isSuccess } = useAppSettingsQuery();

  const areFixturesEnabled = !!data?.appSettings.enableFixtures;

  return (
    <>
      <Helmet>
        <title>{buildDocumentTitle('Données')}</title>
      </Helmet>
      <Breadcrumbs paths={[{ to: PATH_DATA, label: 'données', key: 'data' }]} />
      <PageTitle title="Données" />
      <Stack spacing={2} sx={{ width: '100%' }}>
        <Paper sx={{ p: 2 }}>
          <Typography gutterBottom sx={{ pb: 2 }} variant="h6">
            Chargement
          </Typography>
          {isSuccess && !areFixturesEnabled ? (
            <InfoAlert sx={{ mb: 2 }}>
              Le chargement de jeux de données est désactivé dans cet
              environnement.
            </InfoAlert>
          ) : null}
          <DataSetLoadingForm disabled={!areFixturesEnabled} />
        </Paper>
      </Stack>
    </>
  );
};
